<template>
  <div>
    <base-header class="pb-6" type="blue">
      <div class="row align-items-center py-4">
        <div class="col-lg-6 col-7">
          <h6 class="h2 text-white d-inline-block mb-0">Pricing</h6>
          <!-- <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>-->
        </div>
      </div>
    </base-header>

    <!--Charts-->
    <div class="container-fluid mt--6">
      <div class="row">
        <div class="col">
          <card bodyClasses="px-0 py-1">
            <template>
              <el-table
                class="table-responsive table-flush"
                header-row-class-name="thead-light"
                :data="prices"
              >
                <el-table-column
                  v-for="(column, index) in columns"
                  :key="column"
                  :label="column"
                  sortable
                >
                  <template v-slot="{row}">{{row[index]}}</template>
                </el-table-column>
              </el-table>
            </template>
          </card>
          <!-- <table class="el-table__header">
            <thead class="has-gutter">
              <tr class="thead-light">
                <td v-for="column in columns" :key="column">{{column}}</td>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(row, rowIndex) in prices" :key="rowIndex">
                <td v-for="(column, index) in columns" :key="column">{{row[index]}}</td>
              </tr>
            </tbody>
          </table>-->
        </div>
      </div>
      <!-- End charts-->
    </div>
  </div>
</template>
<script>
import {
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown
} from "element-ui";
export default {
  props: ["category"],
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu
  },
  data() {
    return {
      prices: [],
      columns: []
    };
  },
  watch: {
    category: function() {
      this.loadData();
    }
  },
  methods: {
    loadData() {
      this.prices = [];
      this.columns = [];
      
      this.axios
        .get(`Pricing/${this.category}/Schema`)
        .then(data => this.columns.push(...data.data));

      this.axios
        .get(`Pricing/${this.category}`)
        .then(data => this.prices.push(...data.data));

    }
  },
  mounted() {
    this.loadData();
  }
};
</script>
<style></style>
